import React from 'react';
import { IconProps } from '../types/types';

const LSK: React.FC<IconProps> = (props) => (
    <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 276 326" role="img" {...props}><path d="m138.16 0-29.28 48.7 105.7 181.14L128.83 326s67.4-.4 67 0S276 235.43 276 235.43ZM99.71 66.66 0 236.23 78.57 326h29.55l43.2-50.28h-48L61 228.65l67.8-115.31Z" style={{fill: '#04183d'}}/></svg>
);

export default LSK;
